import UnitCo2e from '@src/components/unit-co2e';
import { formatNumber } from '@src/utils/format-number';
import { useTranslation } from 'react-i18next';

function WasteEmission({ weight, ef }: { weight?: number | undefined; ef: number }) {
    const { t } = useTranslation();

    const totalCarbonFootprint = (weight || 0) * (ef || 0);

    return (
        <div className="mt-4">
            <div className="flex justify-between items-center font-normal">
                <div className=" text-black"> {t('DETAIL_PAGE.WASTE_DETAIL.AMOUNT')}</div>
                <div className=" text-green-600">
                    <span className="px-1">{formatNumber(weight ?? 0, 2)}</span>
                    {t('DETAIL_PAGE.WASTE_DETAIL.AMOUNT_UNIT')}
                </div>
            </div>

            <div className="flex justify-between items-center font-semibold">
                <div className=" text-black"> {t('DETAIL_PAGE.CARBON_FOOTPRINT')}</div>
                <div className=" text-black flex">
                    {totalCarbonFootprint ? totalCarbonFootprint?.toFixed(2) : 0}

                    <UnitCo2e />
                </div>
            </div>
        </div>
    );
}

export default WasteEmission;
